
export function TMBContainer(props) {

    const top_els = props.children.filter(el => el.type == "top").map(el => ({ ...el, type: "div" }));
    const main_els = props.children.filter(el => el.type == "main").map(el => ({ ...el, type: "div"}));
    const bottom_els = props.children.filter(el => el.type == "bottom").map(el => ({ ...el, type: "div" }));

    return (
    <div className="h-screen flex flex-col bg-gray-50">
      <div className="h-13 flow-root">
        {top_els}
      </div>
      <div className="flex-1 overflow-y-auto bg-gray-100">
        {main_els}
      </div>
      <div className="h-14 flow-root bg-gray-200">
        {bottom_els}
      </div>
    </div>
    );
}
